<div class="container">
  <!-- Exit Button (X) positioned at top-right -->
  <button class="exit-btn" (click)="onExit()">X</button>
  <h3>{{ dialogTitle }}</h3> <!-- Dynamic title here -->
  <form [formGroup]="jobForm" (ngSubmit)="onSubmit()">
    <!-- Job Enabled -->
    <div class="form-group">
      <label>
        <input type="checkbox" formControlName="enabled"> Enabled
      </label>
    </div>

    <!-- Client Selection (Global Admin only) -->
    <div class="form-group" *ngIf="isGlobalAdmin">
      <label for="clientId">Client</label>
      <mat-select formControlName="clientId" id="clientId">
        <mat-option *ngFor="let client of clients" [value]="client.id">
          {{ client.displayName }}
        </mat-option>
      </mat-select>
    </div>

    <!-- Function Selection -->
    <div class="form-group">
      <label for="integrationTypeString">Select Function</label>
      <mat-select [(ngModel)]="selectedFunction" formControlName="integrationTypeString">
        <mat-option *ngFor="let func of integrationTypeString" [value]="func.name">
          {{ func.name }}
        </mat-option>
      </mat-select>
    </div>

    <!-- File Import Specific Filter (Schedule File Regex) -->
    <div *ngIf="selectedFunction === 'Import'">
      <div class="filter-container form-group">
        <label for="fileRegex">Schedule File Regex</label>
        <textarea id="fileRegex" formControlName="fileRegex" class="form-control" rows="3" placeholder="[a-zA-Z0-9]+.xlsx(?!\.)"></textarea>
      </div>
    </div>

    <!-- File Export Specific Filters -->
    <div *ngIf="selectedFunction === 'Export'">
      <div class="form-group filter-container">
        <div class="filter-row">
          <span class="filter-label">Regions</span>
          <mat-select class="mat-select-filter" formControlName="region" multiple>
            <mat-option *ngFor="let filter of filters.regions" [value]="filter.value">
              {{ filter.caption }}
            </mat-option>
          </mat-select>
        </div>

        <!-- State/County Filter -->
        <div class="filter-row">
          <span class="filter-label">States/Counties</span>
          <mat-select class="mat-select-filter" formControlName="stateCounty">
            <mat-option *ngFor="let filter of filters.stateCounty" [value]="filter.value">
              {{ filter.caption }}
            </mat-option>
          </mat-select>
        </div>

        <!-- Operator Filter -->
        <div class="filter-row">
          <span class="filter-label">Operators</span>
          <mat-select class="mat-select-filter" formControlName="operator">
            <mat-option *ngFor="let filter of filters.operators" [value]="filter.caption">
              {{ filter.caption }}
            </mat-option>
          </mat-select>
        </div>

        <!-- Scheduled In Next Dropdown -->
        <div class="filter-row">
          <span class="filter-label">Scheduled In</span>
          <mat-select class="mat-select-filter" formControlName="numDays">
            <mat-option *ngFor="let option of scheduleOptions" [value]="option.value">
              {{ option.label }}
            </mat-option>
          </mat-select>
        </div>
      </div>
    </div>

    <!-- Schedule Section (with outline) -->
    <div>
      <label for="schedule">Schedule</label>
    </div>
    <div class="row">
      <div style="width: 100%">
        <div class="card card-sm-10">
          <div class="card-body">
            <cron-editor #cronEditorDemo
                         [(cron)]="cronExpression"
                         [options]="cronOptions">Cron here...</cron-editor>
          </div>
          <span class="demoExpression">Expression: {{cronExpression}}</span>
        </div>
      </div>
    </div>

    <!-- Description Textarea -->
    <div class="form-group">
      <label for="description">Description</label>
      <textarea id="description" formControlName="description" class="form-control" rows="3" placeholder="Job description"></textarea>
    </div>

    <!-- Data Source Dropdown -->
    <div class="form-group">
      <label for="dataSource">Data Source</label>
      <select formControlName="dataSource" id="dataSource" class="form-control" (change)="onDataSourceChange()">
        <option value="" disabled selected>Select Data Source</option>
        <option *ngFor="let source of dataSources" [value]="source.name">{{ source.name }}</option>
      </select>
    </div>

    <!-- Data Source Configuration (Collapsible Area) -->
    <div *ngIf="dataSource" class="form-group">
      <button type="button" class="config-button" (click)="toggleDataSourceConfig()">
        <span *ngIf="isDataSourceConfigVisible">▲</span>
        <span *ngIf="!isDataSourceConfigVisible">▼</span>
        Data Source Configuration
      </button>
      <div *ngIf="isDataSourceConfigVisible" class="data-source-config">
        <!-- FTP Configuration -->
        <div *ngIf="dataSource === 'Ftp' && isDataSourceConfigVisible">
          <div class="form-group">
            <label for="ftpServer">FTP Server</label>
            <input type="text" id="ftpServer" formControlName="ftpServer" class="form-control" placeholder="FTP Server address" />
          </div>

          <div class="form-group">
            <label for="ftpPort">FTP Port</label>
            <input type="number" id="ftpPort" formControlName="ftpPort" class="form-control" value="21" />
          </div>

          <div class="form-group">
            <label for="ftpRootPath">FTP Root Path</label>
            <input type="text" id="ftpRootPath" formControlName="ftpRootPath" class="form-control" placeholder="FTP Root Path" />
          </div>

          <div class="form-group">
            <label for="ftpUser">FTP User</label>
            <input type="text" id="ftpUser" formControlName="ftpUser" class="form-control" placeholder="FTP Username" />
          </div>

          <div class="form-group">
            <label for="ftpPassword">FTP User Password</label>
            <input type="password" id="ftpPassword" formControlName="ftpPassword" class="form-control" placeholder="FTP User Password" />
          </div>

          <div class="form-group">
            <label for="timeout">Timeout (milliseconds)</label>
            <input type="number" id="timeout" formControlName="timeout" class="form-control" value="30000" />
          </div>

          <!-- Secure FTP options -->
          <div class="form-group">
            <label>
              <input type="checkbox" formControlName="enableSecureFtp"> Enable Secure FTP
            </label>
          </div>

          <div class="form-group">
            <label>
              <input type="checkbox" formControlName="enableCertificateValidation"> Enable Certificate Validation
            </label>
          </div>

          <div class="form-group">
            <label>
              <input type="checkbox" formControlName="enablePassiveMode"> Enable Passive Mode
            </label>
          </div>
        </div>

        <!-- SFTP Configuration -->
        <div *ngIf="dataSource === 'Sftp' && isDataSourceConfigVisible">
          <div class="form-group">
            <label for="sftpServer">SFTP Server</label>
            <input type="text" id="sftpServer" formControlName="sftpServer" class="form-control" placeholder="SFTP Server address" />
          </div>

          <div class="form-group">
            <label for="sftpPort">SFTP Port</label>
            <input type="number" id="sftpPort" formControlName="sftpPort" class="form-control" value="22" />
          </div>

          <div class="form-group">
            <label for="sftpRootPath">SFTP Root Path</label>
            <input type="text" id="sftpRootPath" formControlName="sftpRootPath" class="form-control" placeholder="SFTP Root Path" />
          </div>

          <div class="form-group">
            <label for="sftpUser">SFTP User</label>
            <input type="text" id="sftpUser" formControlName="sftpUser" class="form-control" placeholder="SFTP Username" />
          </div>

          <div class="form-group">
            <label for="sftpPassword">SFTP User Password</label>
            <input type="password" id="sftpPassword" formControlName="sftpPassword" class="form-control" placeholder="SFTP User Password" />
          </div>

          <div class="form-group">
            <label for="timeout">Timeout (milliseconds)</label>
            <input type="number" id="timeout" formControlName="timeout" class="form-control" value="30000" />
          </div>
        </div>
      </div>
    </div>
    <!-- Cancel and Submit Buttons -->
    <div class="form-group buttons">
      <button type="button" class="cancel-button" (click)="onCancel()">Cancel</button>
      <button type="submit" class="submit-button" [disabled]="!jobForm.valid">
        {{ dialogTitle === 'Add Job' ? 'Submit' : 'Update' }}
      </button>
    </div>
  </form>
</div>

